import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';

interface ProtectedRouteProps {
    children: React.ReactNode;
    allowedRoles?: string[];
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children, allowedRoles }) => {
    const token = localStorage.getItem('access_token');
    const location = useLocation();

    // Simple check: if no token, redirect to login
    if (!token) {
        return <Navigate to="/login" state={{ from: location }} replace />;
    }

    // In a real implementation with JWT, we would decode the token here
    // and check the 'role' claim against allowedRoles.
    // For this prototype/MVP, we allow access if token exists.

    return <>{children}</>;
};

export default ProtectedRoute;
